// dependencies
import React from "react";
import { Link } from "yarrr";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Power } from "lucide-react";
import { getMatchedRoute, getMatchedRouteKeyValue } from "yarrr";

// hooks
import { useMyPermissions } from "../../../Api/hooks";
import useWindowWidth from "./hooks/useWindowWidth";

// components
import Logo from "assets/img/logo";
import ExtraMenu from "./components/ExtraMenu";
import EnvironmentSwitcher from "Components.Smart/EnvironmentSwitcher";

// selectors
import { getUserRoles } from "Selectors/app";

// css
import css from "./TopNavigation";

const TopNavigation = (props) => {
	const width = useWindowWidth();
	const userRoles = useSelector(getUserRoles);
	const matchedRoute = useSelector(getMatchedRoute);
	let renderableItemCount = Math.floor((width - 250) / 110);

	const { data: permissions } = useMyPermissions();

	const linkItems = [
		{ name: "dashboardPage", href: "/", label: "Dashboard" },
		{ name: "featureFlags", href: "/feature-flags", label: "Feature Flags" },
		{ name: "breadcrumbsPage", href: "/breadcrumbs", label: "Breadcrumbs" },
		{ name: "requestsPage", href: "/requests", label: "Requests" },
		{ name: "recentUsersPage", href: "/recent", label: "Recent Users" },
		{ name: "companiesPage", href: "/companies", label: "Companies" },
		{ name: "reviewSnapshots", href: "/review-snapshots", label: "Review Snapshots" },
		{ name: "environment-status", href: "/environment-status", label: "Environments" },
		{ name: "etl-status", href: "/etl-status", label: "ETL Status" },
		{ name: "deployments", href: "/deployments", label: "Deployments" },
		{ name: "notifications", href: "/notifications", label: "Notifications" },
		{ name: "me", href: "/me", label: "Me" },
		{ name: "ai", href: "/ai/prompt-library", label: "AI" },
		{ name: "decision-log", href: "/decision-log", label: "Decisions" },
		{ name: "jira-tools", href: "/jira-tools", label: "Jira Tools" },
		{ name: "graphsPage", href: "/graphs", label: "Graphs" },
		{ name: "ses-logs", href: "/ses-logs", label: "SES Logs" },
	];

	if (userRoles.includes("engineering")) {
		linkItems.push({ name: "securityAudits", href: "/security-audits", label: "Security Audits" });
		linkItems.push({ name: "schemaReview", href: "/schema-review", label: "Schema Review" });
		linkItems.push({ name: "seed-company", href: "/seed-company", label: "Seed Company" });
	}

	if (userRoles.includes("marketing")) {
		linkItems.push({ name: "marketing", href: "/marketing", label: "Marketing" });
	}

	if (userRoles.includes("super-user-manager")) {
		linkItems.push({ name: "super-users", href: "/super-users", label: "Super Users" });
	}

	if (renderableItemCount < linkItems.length) {
		renderableItemCount -= 1;
	}

	return (
		<div className={css.topNavigation}>
			<div className={css.logoContainer}>
				<Logo width={40} height={40} />
			</div>

			<div className={css.navMenu}>
				<div className={css.innerMenu}>
					<EnvironmentSwitcher className={css.environmentSwitcher} />

					{linkItems.slice(0, renderableItemCount).map((link) => (
						<Link
							key={link.name}
							href={link.href}
							className={`${css.navItem} ${matchedRoute.path === link.href ? css.activeNavItem : ""}`}
						>
							{link.label}
						</Link>
					))}

					{linkItems.slice(renderableItemCount, linkItems.length).length > 0 ? (
						<div className={`${css.extraMenuContainer}`}>
							<ExtraMenu links={linkItems.slice(renderableItemCount, linkItems.length)} />
						</div>
					) : null}

					<Link href="/logout" className={`${css.navItem} ${css.logoutItem}`}>
						<Power size={16} />
					</Link>
				</div>
			</div>
		</div>
	);
};

TopNavigation.propTypes = {
	currentPage: PropTypes.string.isRequired,
};

export default TopNavigation;
